import { createClient } from "@supabase/supabase-js";
import { installRecoverySignal } from "./passwordRecoverySignal";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase URL or anon key is not set in environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Se instala en el MISMO tick que el cliente, a propósito: `createClient` arranca `initialize()`,
// que lee (y después borra) el hash del enlace de recuperación y emite `PASSWORD_RECOVERY` en un
// `setTimeout(0)`. La página de reset es un chunk lazy y monta tarde; si el listener viviera allí
// llegaría después del evento. Ver `passwordRecoverySignal.js`.
if (typeof window !== "undefined") {
  installRecoverySignal(supabase, window.location.href);
}
